import { render, staticRenderFns } from "./candidateTable.vue?vue&type=template&id=8f0adbc2"
import script from "./candidateTable.vue?vue&type=script&lang=js"
export * from "./candidateTable.vue?vue&type=script&lang=js"
import style0 from "./candidateTable.vue?vue&type=style&index=0&id=8f0adbc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports